export enum FilterType {
    Dropdown = 'Dropdown',
    MultiSelect = 'MultiSelect',
    DateRange = 'DateRange',
    ReportDatePeriod = 'ReportDatePeriod',
    DatePicker = 'DatePicker',
    Toggle = 'Toggle',
    TextInput = 'TextInput'
}
